export const getDisplayWeeksCountForWindowWidth = (windowWidth) => {
  if (windowWidth >= 1920) return 10;
  if (windowWidth >= 1700) return 9;
  if (windowWidth >= 1400) return 8;
  return 6;
};